<script lang="ts">
import SectionSalarieFiscalite from '@/generated/sections/SectionSalarieFiscalite.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SectionSalarieFiscalite,
    methods: {
        isDisplayed(value: string): boolean {
            let res = true;
            if (this.displayMap.size == 0) {
                this.displayMap.set("FISCALITE", true);
            }
            const display = this.displayMap.get(value);
            if (display != undefined) {
                res = display;
            }
            return res;
        }
    }
})

</script>
